export const months = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

export const enum NameSpace {
  DataMain = 'DATA_MAIN',
  DataSummary = 'DATA_SUMMARY',
  ReportFactory = 'REPORT_FACTORY',
  FiltersMain = 'DATA_FILTERS',
  Columns = 'COLUMNS',
  Date = 'DATE',
  Settings = 'SETTINGS'
}
